import {
    AnimationBaseController,
    GameRandom,
    IAnimationControllerConfiguration,
    Inject,
    SoundManager, SoundType,
} from '@denishussar/html5-game-engine';
import { GameModel } from '../../../Models/Game/GameModel';
import { AnimationContents } from '../../../../AnimationContents';
import {
    ButtonController,
    IButtonControllerOptions,
} from '../../../Common/ButtonController';
import { GameLogic } from '../../../Logic/GameLogic';
import { TextInput } from '../../../Common/TextInput';
import { SoundConstants } from '../../../Constants/SoundConstants';

export class PlayerNameController extends AnimationBaseController {
    $model: GameModel;

    private _playerName: string = null;

    public constructor(
        @Inject private _options: any,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic,
        @Inject private _soundManager: SoundManager
    ) {
        super('PlayerNameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.INTRO_SCREEN_JSON,
            libraryName: 'container',
            childControllers: {
                StartButton: {
                    instanceName: 'window.btn_ok',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: async () => {
                            await this._gameLogic.saveDB(this._playerName);
                            this._gameLogic.showGameLeaderboards();
                        },
                        hotKey: 'SPACE',
                    },
                },
            },
            sounds: [
                {
                    id: SoundConstants.PAUSE,
                    type: SoundType.Music
                },
            ],
        };
    }

    protected onInitialize(): void {
        if (this._soundManager.isSoundPlaying(SoundConstants.GAME)) {
            this._soundManager.stop(SoundConstants.GAME);
        }
        if (!this._soundManager.isSoundPlaying(SoundConstants.PAUSE)) {
            this._soundManager.play(SoundConstants.PAUSE);
        }

        this._playerName = 'Guest_' + this._random.integer(12, 12000);

        const width = 300;
        const input = new TextInput(this._playerName, {
            input: {
                fontSize: '25pt',
                padding: '14px',
                width: `${width}px`,
                fontFamily: 'Montserrat',
                background: 'none',
                color: '#ffffff',
            },
            box: null,
        });

        input.on('input', value => (this._playerName = value));
        input.x = -width / 2 - 12;
        input.y = 4;

        // @ts-ignore
        this.display.addChild(input);
    }
}
